module.exports = __webpack_public_path__ + "3b8f92bdfdf8e46988d33eb638725495.svg";